<template>
  <div class="relative text-black">
    <div ref="header" class="navbar bg-base-100">
      <div class="navbar-start">
        <div role="button" @click="showMenu = !showMenu" tabindex="0" class="flex btn dropdown p-3 hover:bg-slate-300">
          <div
            class="grid grid-cols-[20px_auto] gap-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h7"
              />
            </svg>
            <div>
              Каталог
            </div>
          </div>
          
        </div>
      </div>
      <div class="navbar-center"></div>
      <div class="navbar-end"></div>
    </div>

    <div v-if="showMenu" class="absolute left-0 z-30 max-w-full" :style="{ top: height }">
      <ul class="menu lg:mb-64 text-2xl bg-white rounded-box shadow-lg "  >
        <template v-for="item in categoryTree">
          <template v-if="item.children && item.children.length > 0">
            <li :key="item.category_id">
              <DetailsTree :item="item"></DetailsTree>
            </li>
          </template>
          <template v-else>
            <li :key="item.category_id">
              <a class="font-bold  " :href="item.page_url">{{ item.name }}</a>
            </li>
          </template>
        </template>
      </ul>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { CategoryItemTree, MainMenuProps } from '@/types/book_item'
import { DetailsTree } from '@/components/MainMobileMenu'
import { ref } from 'vue'
import { buildTree } from './MainMenu'
import { useElementSize } from '@vueuse/core'

const props = defineProps<{
  props: MainMenuProps
}>()
const showMenu = ref(false)
const categoryTree = ref<CategoryItemTree[]>([])
const header = ref(null)

const { height } = useElementSize(header)

categoryTree.value = buildTree(props.props.items)
</script>
